import {Component} from 'react';
import axios from "axios"
import Nav from "../Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import {Line, Pie,Bar} from 'react-chartjs-2';
import {
    ArcElement,
    CategoryScale,
    Chart,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    BarElement,
} from 'chart.js';

Chart.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
let source = axios.CancelToken.source();

class Dashboard3 extends Component {
    constructor() {
        super();
        this.state = {
            objs: [],
            objsload: false,
        }
    }
    tablebest=()=> {
        let retdata = null;
        if (this.state.objsload) {
            let count = 0;
            retdata = this.state.objs.best5.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.score}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    tableworst=()=> {
        let retdata = null;
        if (this.state.objsload) {
            let count = 0;
            retdata = this.state.objs.worest5.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.score}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    componentDidMount() {
        this.fetcheddata()
    }
    fetcheddata = () => {
        let baseurl = myconfig.getdashboard3;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            objs: [],
            objsload: false,
        })
        axios.post(baseurl, {
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs: res.data,
                    objsload: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    chartlinevio=()=> {
        let retdata=null;
        if(this.state.objsload) {
            let data = {
                labels: this.state.objs.lables,
                datasets: [
                    {
                        label: "Total Violation",
                        data: this.state.objs.vios,
                        fill: true,
                        backgroundColor: "rgba(75,192,192,0.2)",
                        borderColor: "rgba(75,192,192,1)"
                    },
                ]
            };
            retdata = <Line data={data}/>;
        }
        return (<>{retdata}</>)
    }
    chartverbarviotrend=()=> {
        let retdata=null;
        if(this.state.objsload) {
            let options = {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top',
                    },
                    title: {
                        display: true,
                        text: 'Violation Trend\'s',
                    },
                },
            };
            let labels = this.state.objs.lables;
            let data = {
                labels,
                datasets: [
                    {
                        label: 'Speeding',
                        data: this.state.objs.sped,
                        backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    },
                    {
                        label: 'Hash Acceleration',
                        data: this.state.objs.ad,
                        backgroundColor: 'rgba(53, 162, 21, 0.5)',
                    },
                    {
                        label: 'Harsh Braking',
                        data: this.state.objs.bd,
                        backgroundColor: 'rgba(53, 162, 235, 0.5)',
                    },
                    {
                        label: 'Harsh Cornering',
                        data: this.state.objs.cd,
                        backgroundColor: 'rgba(53, 16, 1, 0.5)',
                    },
                ],
            };
            retdata = <Bar options={options} data={data}/>
        }
        return (<>{retdata}</>)
    }
    render() {
        return (
            <>
                <Nav type="dashboard3"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Driver Performance</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                                        <li className="breadcrumb-item active">Performance</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-md-6">
                                    <div className="card card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">Best Top 5 Driver</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Truck #</th>
                                                    <th>Driver Name</th>
                                                    <th>Phone #</th>
                                                    <th>Score</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tablebest()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="card card-danger">
                                        <div className="card-header">
                                            <h3 className="card-title">Worst Top 5 Driver</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Truck #</th>
                                                    <th>Driver Name</th>
                                                    <th>Phone #</th>
                                                    <th>Score</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tableworst()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="card card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">Violation By Week</h3>
                                        </div>
                                        <div className="card-body">
                                            {this.chartlinevio()}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="card card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">Violation Trend's</h3>
                                        </div>
                                        <div className="card-body">
                                            {this.chartverbarviotrend()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Dashboard3;
